import React from "react";
import { Flex, Text, Button } from "@chakra-ui/react";
import { bookingFlowStore } from "../../store/BookingFlowStore";
import { servicebookingFlowStore } from "../../store/ServiceBookingFlowStore";
import { useAlert } from '../AlertProvider';

interface Step2Props {
  isForFamilyMember: boolean;
}

const Step2_ExistingPatient: React.FC<Step2Props> = ({ isForFamilyMember }) => {
  const { showAlert: showPopUpAlert } = useAlert();

  const isServiceBooking = servicebookingFlowStore.isServiceBooking;

  const handleNext = (isExisting: boolean) => {
    if (!isExisting && servicebookingFlowStore.appointmentData?.appointmentType?.new_patient === "0") {
      showPopUpAlert({
        severity: "warning",
        title: "This Appointment type not for new Patients",
        message: "Then please select other Appointment type.",
        onClose: () => {
          servicebookingFlowStore.setIsModalOpen(false);
        },
      });
      return;
    }
    bookingFlowStore.updateAppointmentData("isExistingPatient", isExisting);
    bookingFlowStore.nextStep();
    bookingFlowStore.setActiveStep(bookingFlowStore.currentStep);

    servicebookingFlowStore.updateAppointmentData("isExistingPatient", isExisting);
    servicebookingFlowStore.nextStep();
    servicebookingFlowStore.setActiveStep(bookingFlowStore.currentStep);

    // console.log(
    //   "Appointment Type data",
    //   servicebookingFlowStore.appointmentData
    // );





    // if (!isExisting && patientStore.currentPatient.is_new_pt === "1") {
    //   console.log("You don't belong here");
    //   // TODO : SHOW ALERT TO SELECT ANOTHER DOCTOR OR APPOINTMENT TYPE
    //   return;
    // }

    // servicebookingFlowStore.updateAppointmentData(
    //   "isExistingPatient",
    //   isExisting
    // );
    // servicebookingFlowStore.nextStep();
    // servicebookingFlowStore.skipServiceTypeSelection = true;
    // servicebookingFlowStore.setActiveStep(
    //   servicebookingFlowStore.currentStep + 1
    // );
  };

  // if (patientStore.currentPatient.is_new_pt ) {

  //   servicebookingFlowStore.nextStep();
  //   servicebookingFlowStore.skipServiceTypeSelection = true;
  //   servicebookingFlowStore.setActiveStep(
  //     servicebookingFlowStore.currentStep + 1
  //   );
  // }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
      {/* {patientStore.currentPatient.is_new_pt} */}
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        {isForFamilyMember
          ? `Is your family member an existing patient${servicebookingFlowStore?.isServiceBooking && servicebookingFlowStore?.appointmentData?.selectedDoctor?.location_display_name
            ? ` in ${servicebookingFlowStore.appointmentData.selectedDoctor.location_display_name}`
            : ""
          }?`
          : `Are you an existing patient${servicebookingFlowStore?.isServiceBooking && servicebookingFlowStore?.appointmentData?.selectedDoctor?.location_display_name
            ? ` in ${servicebookingFlowStore.appointmentData.selectedDoctor.location_display_name}`
            : ""
          }?`}
      </Text>


      <Flex gap={4} flexDirection={{ base: "column", md: "row" }}>
        <Button
          variant="outline"
          borderColor={isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F"}
          color={isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F"}
          border="2px"
          _hover={{
            bg: isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F",
            color: "#fff",
            border: "2px",
            borderColor: isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F",
          }}
          onClick={() => handleNext(false)}
        >
          {isForFamilyMember
            ? "No, They are a New Patient"
            : "No, I am a New Patient"}
        </Button>
        <Button
          bg={isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "#B92F2F"}
          color="white"
          _hover={{ bg: isServiceBooking ? servicebookingFlowStore?.configurationDetails?.colorScheme?.buttonBg : "red.700" }}
          onClick={() => handleNext(true)}
        >
          {isForFamilyMember
            ? "Yes, They are an Existing Patient"
            : "Yes, I am an Existing Patient"}
        </Button>
      </Flex>
    </Flex>
  );
};

export default Step2_ExistingPatient;
